import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Button, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomList from '../../components/CustomList';
import DefaultImg from '../../assets/images/jb_link_img.jpg'
import Seo from '../../components/Seo/Seo';

const BlogDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/blog')
  }
    
  const getYouTubeVideoId = (url) => {
    if(url){
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    }else{
      return "jb"
    }
  };
    return (
        <>
        <Seo
          title={state?.title ? `${state.title} | JB Architects & Engineers` : "Blog | JB Architects & Engineers, Tirunelveli"}
          description={state?.context || "Insights and ideas on architecture, home design, and construction from JB Architects & Engineers, Tirunelveli."}
          keywords={[
            "how to choose an architect in tirunelveli",
            "cost of building a house in tirunelveli",
            "modern house elevation design ideas",
          ]}
          path="/blog-details"
          image={state?.image || undefined}
        />
        <div className='container p-4' style={{marginBottom:"100px"}}>
        <Button sx={{
                position:'fixed',
                bottom:25,
                left:20,
                borderRadius:"25px",
                backgroundColor:"#121212"
              }} 
              onClick={handleBack} 
              variant="contained" 
              startIcon={<ArrowBackIcon />}>
                Back
              </Button>
        <Paper elevation={3}>
            
            <div style={{height:"70vh"}} className='text-center p-2 '>
                {state?.mediaType === 'youtubeVideo' 
                    ?
                    <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${getYouTubeVideoId(state?.youtube)}?si=T8Ww0k57R7pGhfU9`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> 
                    :
                   <img src={state?.image || DefaultImg} alt="jb architects and engineers tirunelveli" style={{maxHeight:"100%",maxWidth:"100%"}} />
                }
            </div>
            <div className='p-4'>
                  <h3 className='p-2'>
                    {state?.title}
                  </h3>
                  {/* <p className='p-2'>
                    {state?.context}
                  </p> */}

                  <div className='p-2'>
                    <div dangerouslySetInnerHTML={{ __html: state?.content }}></div>
                  </div>
                  <CustomList 
                       title={state?.pointDetails?.pointsTitle} 
                       points={state?.pointDetails?.points} 
                       pointStyle={state?.pointDetails?.customMarker}  
                  />
                  <p>
                    {state?.description}
                  </p>
            </div>
              
        </Paper>
        </div>
        </>
    )
}

export default BlogDetail;